import {
  Box,
  IconButton,
  useTheme,
  Tooltip,
  ListItemIcon,
  Avatar,
  MenuItem,
  Menu,
  Divider,
  Button,
} from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const redirect = (path) => {
    //const confirm = window.confirm("Are you sure, you want to logout");
    //if(confirm)
    //{
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Logout!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/logout`,
            {},
            {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {})
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.errorMessage
            ) {
              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                //  type: "error"
              });
            }
          });
        localStorage.removeItem("token");
        navigate(path);
      }
    });
  };

  return (
    <Box
      display="flex"
      justifyContent="right"
      p={1}
      style={{
        boxShadow: "rgba(0, 30, 43, 0.1) 0px 4px 4px 0px",
        backgroundColor: "white",
      }}
    >
      {/* <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box> */}

      {/* <Box display="flex">
        <Tooltip title="Account settings">
        <IconButton 
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
          <PersonOutlinedIcon />
        </IconButton>
        </Tooltip>
        <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        
        <MenuItem onClick={()=>redirect('/')}>
          <ListItemIcon >
          <PersonOutlinedIcon  />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      </Box> */}

      <Button
        style={{
          margin: "0",
          fontSize: "17px",
          color: "rgb(0, 104, 74)",
          fontFamily: "Poppins",
        }}
        onClick={() => redirect("/")}
      >
        Logout&nbsp;
        <LogoutIcon style={{ verticalAlign: "middle" }} />
      </Button>
    </Box>
  );
};

export default Topbar;
